import { FeatureFlagsConfig } from "./models/feature-flag.model";

export const featuresConfig: FeatureFlagsConfig = {
  openAIIntegration: "LIVE",
  reviewSystem: "LIVE",
  analyticsEngagement: "DEVELOPMENT",
  aiStudentAssistantSetting: "LIVE",
  aiStudentAssistantChat: "LIVE",
  stripeTaxIntegration: "LIVE",
  ochApiIntegration: "DEVELOPMENT",
  emailTemplate: "LIVE",
  stripeMultiplePaymentMethods: "LIVE",
  courseAiThumbnailGenerator: "LIVE",
  courseAiTitleGenerator: "LIVE",
  scormUpload: "LIVE",
  onBoardingTutorials: "LIVE",
  videoTutorials: "LIVE",
  studentDetailEnrollmentTab: "LIVE",
  assessment: "LIVE",
  studentDetailAssessmentTab: "LIVE",
  teamMember: "LIVE",
  newProductTypeCoachingSession: "LIVE",
  newProductTypeDigitalDownload: "LIVE",
  newProductTypeExam: "LIVE",
  newProductTypeLiveSession: "LIVE",
  newProductTypeWebinar: "LIVE",
  liveSessionLesson: "LIVE",
  webinarLesson: "LIVE",
  studentProgressMatrix: "LIVE",
  ImprovedCertificate: "LIVE",
  courseNotes: "LIVE",
  communityRevamp: "QA-TEST",
};
